<template>
  <div class="customs-svg-icon" v-html="svgContent" ></div>
</template>

<script>
export default {
  name: 'customsSvgIcon',
  props: {
    src: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      svgContent: '',
    }
  },
  created() {
    fetch(this.src)
      .then(response => {
        if(response.status !== 200) {
          throw response;
        }
        return response.text()
      })
      .then(content => {
        this.svgContent = content;
      })
      .catch(ex => {
        console.error('Could not load the svg file from the url.', ex);
      });
  },
}
</script>
